import { NgModule } from '@angular/core';

import {
    MatInputModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
} from '@angular/material';

@NgModule({
    imports: [
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatSnackBarModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatSortModule
    ],
    exports: [
        MatInputModule,
        MatSnackBarModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        MatProgressSpinnerModule,
    ]
})
export class MaterialModule { }


// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/material.module.ts